import { takeLatest, call, put, select } from 'redux-saga/effects';

import { setSessionStorage } from '@tcp/core/src/utils';
import BOSS_UNAVAILABLE_CONSTANTS from './BossUnavailable.constants';
import moveItemsToBossUnavailable, {
  fetchBossUnavailableProducts,
  getConvertedBossUnavailableProducts,
  removeBossUnavailableProducts,
} from '../../../../../../../services/abstractors/CnC/BossUnavailable';
import BAG_PAGE_ACTIONS from '../../../../BagPage/container/BagPage.actions';
import {
  setBossUnavailableList,
  setBossUnavailableListID,
  setConvertedBossUnavailableList,
  setRemovedItemsBossUnavailableList,
  removeDeletedItem,
  addDeletedItemOnAPiFailure,
} from './BossUnavailable.actions';
import logger from '../../../../../../../utils/loggerInstance';
import { getCartOrderId } from '../../../container/CartItemTile.selectors';

export function* moveItemsToBossUnavailableList({ payload }) {
  const orderIds = [];
  payload?.forEach((item) => {
    orderIds.push(item?.itemId);
  });

  try {
    const deletedProductInfo = {
      orderId: yield select(getCartOrderId),
      orderItems: orderIds,
    };
    yield put(BAG_PAGE_ACTIONS.removeDeletedItem(deletedProductInfo));
    const response = yield call(moveItemsToBossUnavailable, payload);
    if (response?.data?.length > 0) {
      yield put(BAG_PAGE_ACTIONS.getCartData({ skipCache: true, fromBossUnavailable: true }));
    }
    yield put(setBossUnavailableList(response?.data));
    yield put(setBossUnavailableListID(response?.listId));
  } catch (e) {
    yield put(BAG_PAGE_ACTIONS.addDeletedItemOnAPiFailure());
    logger.error('Error has occurred : ', {
      error: e,
      extraData: {
        component: 'Boss Unavailable Saga - moveItemsToBossUnavailableList',
        payloadRecieved: payload,
      },
    });
  }
}

export function* fetchBossUnavailableList({ payload }) {
  try {
    const response = yield call(fetchBossUnavailableProducts, payload);
    yield put(setBossUnavailableList(response?.data));
    yield put(setBossUnavailableListID(response?.listId));
  } catch (e) {
    logger.error('Error has occurred : ', {
      error: e,
      extraData: {
        component: 'Boss Unavailable Saga - fetchBossUnavailableList',
        payloadRecieved: payload,
      },
    });
  }
}

export function* removeBossUnavailableItem({ payload }) {
  try {
    const deletedProductInfo = {
      orderId: yield select(getCartOrderId),
      orderItems: [payload?.itemId],
    };
    yield put(removeDeletedItem(deletedProductInfo));
    const response = yield call(removeBossUnavailableProducts, payload);
    yield put(setBossUnavailableList(response?.data));
    yield put(setBossUnavailableListID(response?.listId));
  } catch (e) {
    yield put(addDeletedItemOnAPiFailure());
    logger.error('Error has occurred: ', {
      error: e,
      extraData: {
        component: 'Boss Unavailable Saga - removeBossUnavailableItem',
        payloadRecieved: payload,
      },
    });
  }
}

export function* fetchConvertedBossUnavailableItem({ payload }) {
  try {
    const response = yield call(getConvertedBossUnavailableProducts, payload);
    yield put(setConvertedBossUnavailableList(response?.basketItems));
    yield put(setRemovedItemsBossUnavailableList(response?.removedItems));
    yield put(setBossUnavailableList([]));
    if (response?.basketItems) {
      const prodPartNumbers = response?.basketItems?.map((item) => item.cProdPartNo);
      const separator = '___';
      const arrayString = prodPartNumbers?.join(separator);
      setSessionStorage({ key: 'bossUnavailableItems', value: arrayString });
    }
  } catch (e) {
    logger.error('Error has occurred: ', {
      error: e,
      extraData: {
        component: 'Boss Unavailable Saga - fetchConvertedBossUnavailableItem',
        payloadRecieved: payload,
      },
    });
  }
}

function* BossUnavailableSaga() {
  yield takeLatest(
    BOSS_UNAVAILABLE_CONSTANTS.MOVE_BOSS_UNAVAILABLE_ITEMS,
    moveItemsToBossUnavailableList
  );
  yield takeLatest(
    BOSS_UNAVAILABLE_CONSTANTS.FETCH_BOSS_UNAVAILABLE_ITEMS,
    fetchBossUnavailableList
  );
  yield takeLatest(
    BOSS_UNAVAILABLE_CONSTANTS.REMOVE_BOSS_UNAVAILABLE_ITEM,
    removeBossUnavailableItem
  );
  yield takeLatest(
    BOSS_UNAVAILABLE_CONSTANTS.FETCH_CONVERTED_BOSS_UNAVAILABLE_ITEM,
    fetchConvertedBossUnavailableItem
  );
}

export default BossUnavailableSaga;
